export default __webpack_public_path__ + "static/media/fileIcon.30e65862.svg";